import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse, AxiosError } from 'axios';

import Container from 'components/container';
import Button from 'components/button';

import Form from 'react-bootstrap/Form';

import { fetch } from 'services/fetch';
// import routes:
import { dashboard } from 'routes/uris';
// import styles:
import 'assets/styles/login.scss';

const LoginComponent = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [validated, setValidated] = useState<boolean>(false);
    const [credentialsAreWrong, setCredentialsAreWrong] = useState<boolean>(false);

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const onSubmit = (ev: React.MouseEvent<HTMLFormElement>) => {
        const formElement = ev.currentTarget;

        // prevent submit action
        ev.preventDefault();

        if (!formElement.checkValidity()) {
            ev.stopPropagation();
        }
        
        setValidated(true);
        
        if (formElement.reportValidity()) {
            setCredentialsAreWrong(false);
            setIsLoading(true);

            fetch('/login', 'POST', { email, password })
                .then(({ data }: AxiosResponse)  => {
                    window.localStorage
                        .setItem('token', data.token);

                    navigate(dashboard);
                })
                .catch((e: AxiosError) => {
                    if (e.response.status === 403) {
                        setCredentialsAreWrong(true);    
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    return (
        <Container>
            <div className="card card-login">
                <div className="card-body">
                    <h5 className="card-title">
                        Login
                    </h5>

                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                        <Form.Group className="mb-2" controlId="formLoginEmail">
                            <Form.Label>Email:</Form.Label>
                            <Form.Control
                                name="email"
                                type="email"
                                value={email}
                                onChange={({ target }) => setEmail(target.value)}
                                required
                            />

                            <Form.Control.Feedback type="invalid">
                                This field is required
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-2" controlId="formLoginPassword">
                            <Form.Label>Password:</Form.Label>
                            <Form.Control
                                name="password"
                                type="password"
                                value={password}
                                onChange={({ target }) => setPassword(target.value)}
                                required
                            />

                            <Form.Control.Feedback type="invalid">
                                This field is required
                            </Form.Control.Feedback>
                        </Form.Group>
                        
                        {(credentialsAreWrong === true) && (
                            <Form.Text className="text-danger">
                                Invalid email or password
                            </Form.Text>
                        )}

                        <div className="d-grid mt-1">
                            <Button type="submit" loading={isLoading}>
                                Sign In
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </Container>
    );
};

export default LoginComponent;
